import * as React from 'react';

interface PickListItemProps {
  id: string;
  isSelected: boolean;
  children: React.ReactNode;
  onItemClick: (id: string, event: React.MouseEvent) => void;
}

export function PickListItemComponent({
  id,
  isSelected,
  children,
  onItemClick,
}: PickListItemProps) {
  return (
    <div
      role="option"
      aria-selected={isSelected}
      className={`bmwe-picklist-item ${isSelected ? 'selected' : ''}`}
      onClick={(e: React.MouseEvent) => {
        onItemClick(id, e);
      }}
    >
      {children}
    </div>
  );
}
